

<wa-dropdown
[attr.label-before]="name_filter ? (name_filter | transloco) : ''"
theme="landing"
 class="filters__label__text"
#combo
[attr.withTextSearch]="allConfig.withTextSearch"
[attr.selectMultiple]="allConfig.selectMultiple"
[attr.property-name]="option_name_property" [attr.selected-item]="selected ? (selected |json ): ''" [attr.list-items]='filterOptionsData(options) |json' [attr.default-text]='name_filter ? (name_filter | transloco) : ""' >
</wa-dropdown>
<mat-icon (click)="clearCombo()" *ngIf="allConfig.selectMultiple && selected.length > 1">cancel</mat-icon>
